module.exports = __webpack_public_path__ + "static/media/longpool.2a263562.jpg";